<div
  class="photos-wrapper d-flex flex-wrap"
  infiniteScroll
  [infiniteScrollDistance]="0.5"
  [fromRoot]="true"
  (scrolled)="onScrolled()"
>
  <input
    style="display: none"
    type="file"
    accept="image/x-png,image/gif,image/jpeg"
    (change)="onFileChanged($event.target.files)"
    #fileInput
  />
  <div
    class="photo-item add-item d-flex flex-column align-items-center justify-content-center"
    (click)="fileInput.click()"
    *ngIf="canAddPhoto"
  >
    <div class="icon">
      <svg viewBox="0 0 80 71">
        <use href="#new-add-photo" />
      </svg>
    </div>
    <div class="title">Add a photo</div>
  </div>
  <app-club-media-photos-section
    [photos]="photos?.slice(i * 20, i * 20 + 20)"
    (startLoading)="onStartLoadingPhotosSection()"
    (loaded)="onLoadedPhotosSection()"
    (remove)="onRemove($event)"
    (select)="onToggleImageFullscreen(i, $event)"
    *ngFor="let i of sections"
  ></app-club-media-photos-section>
  <!-- <div class="photo-item" *ngFor="let photo of photos index as i" (click)="onToggleImageFullscreen(i)">
        TODO: move to sep component, highlight close on mouse move
        <div class="remove" (click)="onRemove(photo.id); $event.stopPropagation(); false">
            <svg viewBox="0 0 26 26">
                <use href="#cancel" />
            </svg>
        </div>
        <img [src]="photo.thumb_url | baseUrl" class="img-fluid">
    </div> -->
  <app-loader-2 *ngIf="isLoadingMore"></app-loader-2>
</div>

<!-- TODO: move to the separate modal logic, duplicated within posts and messages -->
<app-image-viewer
  *ngIf="imageIndex !== null"
  [images]="photos"
  [index]="imageIndex"
  (close)="onToggleImageFullscreen(null, null)"
></app-image-viewer>
